/* Jam grid gallery — hover/swipe product-tile carousel.
   Desktop: transform slider driven by pointer drag + hover.
   Touch devices: native scroll-snap carousel so the OS arbitrates
   horizontal swipe vs vertical page scroll (keeps scrolling effortless).
   Event-delegated so it survives AJAX re-renders of the collection grid. */
(function () {
  if (window.__jamGallery) return;
  window.__jamGallery = true;

  var hoverFine = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function hydrate(g) {
    var imgs = g.querySelectorAll('img[data-src]');
    for (var k = 0; k < imgs.length; k++) {
      imgs[k].src = imgs[k].getAttribute('data-src');
      imgs[k].removeAttribute('data-src');
    }
  }

  function setDots(g, i) {
    var dots = g.querySelectorAll('.jam-gallery__dots li');
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
  }

  if (hoverFine) {
    /* ---------- desktop: pointer-drag transform slider ---------- */

    function go(g, i) {
      var track = g.querySelector('.jam-gallery__track');
      var n = track.children.length;
      i = Math.max(0, Math.min(n - 1, i));
      g.dataset.i = i;
      track.style.setProperty('--i', i);
      track.style.transform = '';
      setDots(g, i);
    }

    var drag = null;

    document.addEventListener('dragstart', function (e) {
      if (drag) { e.preventDefault(); return; }
      var host = e.target.closest && e.target.closest('.grid-product__image-mask, [data-jam-gallery]');
      if (host && (host.hasAttribute('data-jam-gallery') || host.querySelector('[data-jam-gallery]'))) e.preventDefault();
    }, true);

    document.addEventListener('pointerdown', function (e) {
      var g = e.target.closest && e.target.closest('[data-jam-gallery]');
      if (!g) return;
      hydrate(g);
      drag = { g: g, x: e.clientX, moved: false, w: g.offsetWidth || 300 };
      g.querySelector('.jam-gallery__track').classList.add('is-dragging');
    }, true);

    document.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (Math.abs(dx) > 8) drag.moved = true;
      if (drag.moved) e.preventDefault();
      var i = +(drag.g.dataset.i || 0);
      drag.g.querySelector('.jam-gallery__track').style.transform =
        'translateX(calc(' + i + ' * -100% + ' + dx + 'px))';
    }, { passive: false });

    function endDrag(e, cancelled) {
      if (!drag) return;
      var g = drag.g;
      var dx = cancelled ? 0 : e.clientX - drag.x;
      var track = g.querySelector('.jam-gallery__track');
      track.classList.remove('is-dragging');
      var i = +(g.dataset.i || 0);
      if (Math.abs(dx) > drag.w * 0.15) i += dx < 0 ? 1 : -1;
      go(g, i);
      if (drag.moved) {
        g.setAttribute('data-suppress', '1');
        setTimeout(function () { g.removeAttribute('data-suppress'); }, 120);
      }
      drag = null;
    }
    document.addEventListener('pointerup', function (e) { endDrag(e, false); });
    document.addEventListener('pointercancel', function (e) { endDrag(e, true); });

    document.addEventListener('click', function (e) {
      var g = e.target.closest && e.target.closest('[data-jam-gallery]');
      if (g && g.hasAttribute('data-suppress')) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    document.addEventListener('mouseover', function (e) {
      var mask = e.target.closest && e.target.closest('.grid-product__image-mask');
      if (!mask) return;
      var g = mask.querySelector('[data-jam-gallery]');
      if (!g || g.classList.contains('is-active')) return;
      hydrate(g);
      g.classList.add('is-active');
      if (+(g.dataset.i || 0) === 0) go(g, 1);
    });

    document.addEventListener('mouseout', function (e) {
      var mask = e.target.closest && e.target.closest('.grid-product__image-mask');
      if (!mask || (e.relatedTarget && mask.contains(e.relatedTarget))) return;
      var g = mask.querySelector('[data-jam-gallery]');
      if (!g) return;
      g.classList.remove('is-active');
      go(g, 0);
    });

  } else {
    /* ---------- touch: native scroll-snap carousel ---------- */

    function ready(g) {
      var imgs = g.querySelectorAll('.jam-gallery__track img');
      for (var k = 0; k < imgs.length && k < 2; k++) {
        if (imgs[k].hasAttribute('data-src')) {
          imgs[k].src = imgs[k].getAttribute('data-src');
          imgs[k].removeAttribute('data-src');
        }
      }
      if (g.classList.contains('is-ready')) return;
      var first = imgs[0];
      var show = function () { g.classList.add('is-ready'); };
      if (first.complete && first.naturalWidth) show();
      else {
        first.addEventListener('load', show, { once: true });
        first.addEventListener('error', show, { once: true });
      }
    }

    document.addEventListener('touchstart', function (e) {
      var g = e.target.closest && e.target.closest('[data-jam-gallery]');
      if (g) { hydrate(g); ready(g); }
    }, { capture: true, passive: true });

    // keep dots in sync with native scroll position
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('jam-gallery__track')) return;
      var g = t.closest('[data-jam-gallery]');
      if (!g) return;
      var i = Math.round(t.scrollLeft / (t.clientWidth || 1));
      if (String(i) !== g.dataset.i) { g.dataset.i = i; setDots(g, i); }
    }, true);

    // Only after the page has fully loaded (so the theme's own images win
    // the bandwidth race), quietly prep galleries as they near the viewport.
    var boot = function () {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('[data-jam-gallery]').forEach(ready);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { ready(entry.target); io.unobserve(entry.target); }
        });
      }, { rootMargin: '150px' });
      var observeAll = function () {
        document.querySelectorAll('[data-jam-gallery]').forEach(function (g) { io.observe(g); });
      };
      observeAll();
      new MutationObserver(observeAll).observe(document.body || document.documentElement, { childList: true, subtree: true });
    };
    if (document.readyState === 'complete') boot();
    else window.addEventListener('load', function () { setTimeout(boot, 300); }, { once: true });
  }
})();
